import {
  Component, Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'breadcrumb.template.html',
  styleUrls: [
    'breadcrumb.style.scss'
  ]
})
export class BreadcrumbComponent {

  @Input()
  public crumbs: any[];

}
